import type { IconData } from '@stacksjs/iconify-core'

export const moneyPaymentsCreditCardVisa: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 23.62h-1.52v1.52H3.04v1.53h1.53v1.52h25.9v-1.52H32V8.38h-1.53z\"/><path fill=\"currentColor\" d=\"M27.43 5.33h1.52V22.1h-1.52Zm-6.1 4.58h3.05v1.52h-3.05Zm3.05 3.04h-3.05v-1.52h-1.52v6.09h1.52v-3.04h3.05v3.04h1.52v-6.09h-1.52zm-7.62 1.53h1.52V16h-1.52Zm-3.05-1.53h3.05v1.53h-3.05Zm0-3.04h4.57v1.52h-4.57ZM12.19 16h4.57v1.52h-4.57Zm0-4.57h1.52v1.52h-1.52ZM9.14 9.91h1.52v7.61H9.14Zm-3.05 0h1.53V16H6.09ZM4.57 16h1.52v1.52H4.57ZM3.04 9.91h1.53V16H3.04Zm-1.52-6.1h25.91v1.52H1.52Zm0 18.29h25.91v1.52H1.52ZM0 5.33h1.52V22.1H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default moneyPaymentsCreditCardVisa
